// SEO metadata for HIG Automation pages.
// Edit this file to update page titles, descriptions and canonical URLs.

export const pageSeo = {
  home: {
    title: "HIG Automation | Industrial Automation, SPM & Engineering Solutions India",
    description:
      "HIG Automation India provides industrial automation, PLC and SCADA, SPM manufacturing, conveyor systems, control panels and fabrication solutions.",
    canonical: "https://higautomation.com/",
  },
  about: {
    title: "About HIG Automation India | Industrial Engineering Team",
    description:
      "Learn about HIG Automation India, our engineering capability, mission and end-to-end approach to industrial automation and manufacturing projects.",
    canonical: "https://higautomation.com/about",
  },
  services: {
    title: "Industrial Automation & Engineering Services | HIG Automation",
    description:
      "Explore HIG Automation services including PLC and SCADA, paint shop automation, SPMs, conveyors, fire protection, AHU utilities, panels and fabrication.",
    canonical: "https://higautomation.com/services",
  },
  products: {
    title: "Industrial Automation Products & Components | HIG Automation",
    description:
      "Browse robotics, industrial sensors, pneumatic components and electrical automation products available through HIG Automation.",
    canonical: "https://higautomation.com/products",
  },
  industries: {
    title: "Industries We Serve | HIG Automation India",
    description:
      "Automation and engineering solutions for automotive, electronics, pharma, medical devices and manufacturing industries.",
    canonical: "https://higautomation.com/industries",
  },
  contact: {
    title: "Contact HIG Automation | Request an Industrial Automation Quote",
    description:
      "Contact HIG Automation in Rewari, Haryana for industrial automation, SPM, conveyor, control panel, fabrication and engineering requirements.",
    canonical: "https://higautomation.com/contact",
  },
};
